/**
 * V3: Newsroom Nav
 *
 * @module components/NewsroomNav
 */


// Dependencies
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core component init
 *
 * @return  {void}
 */
function _componentInit()
{
	if ($('.module-newsroom__lister__nav').length)
	{
		var select = $('.module-newsroom__lister__nav select');
		var years = $('.module-newsroom__lister__nav ul');

		years.children('li').each(function ()
		{
			var anchor = $(this).find('a');

			if (anchor.length)
			{
				if (anchor.attr('aria-current') == 'page')
				{
					$('<option selected="selected" value="' + anchor.attr('href') + '">' + anchor.text() + '</option>').appendTo(select);
				} else
				{
					$('<option value="' + anchor.attr('href') + '">' + anchor.text() + '</option>').appendTo(select);
				}
			}
		});

		select.on('change', function ()
		{
			if (select.val() != '')
			{
				window.location.href = select.val();
			}
		});
	}
}


// Auto Init
// ============================================================================

$( document ).ready( () => _componentInit() );